// Module
var code = "<div ref=\"valueEditorContainer\">\n\n</div>";
// Exports
module.exports = code;